class StockAlert extends HTMLElement {
    constructor() {
        super();

        this.initAlertForm = this.initAlertForm.bind(this);
        this.sendKlaviyoForm = this.sendKlaviyoForm.bind(this);
        this.isValidEmail = this.isValidEmail.bind(this);
    }

    connectedCallback() {
        this.alertForm = this.querySelector('.js-stock-alert-form');
        this.alertBtn = this.querySelector('.js-stock-alert-btn');

        this.mobileBreakpoint = 1024;
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;

        // reveal form
        this.alertBtn.addEventListener('click', () => {
            this.alertBtn.classList.add('invisible');
            this.alertForm.classList.remove('hidden');
            this.initAlertForm();
        });
    }

    initAlertForm() {
        this.alertFormBtn = this.querySelector('.js-form-alert-submit');
        this.alertFormInput = this.querySelector('.js-form-alert-input');

        this.alertFormInput.focus();
        this.alertFormInput.addEventListener('keyup', (e) => {
            if (e.key === 'Enter') {
                this.alertFormBtn.click();
            }
        });

        this.alertFormBtn.addEventListener('click', this.sendKlaviyoForm);
    }

    async sendKlaviyoForm(e) {
        e.preventDefault();

        // get and check email
        const email = this.alertFormInput.value;

        if (!this.isValidEmail(email)) {
            document.querySelector('.js-email-error').classList.remove('hidden');
            return;
        }

        // build klaviyo datas
        const KLAVIYO_URL = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
        const variantId = this.dataset.productId;
        const klaviyoApiKey = this.dataset.klaviyoKey;

        if (!variantId || !email || !klaviyoApiKey) { 
            return 
        }

        const klaviyo_data = {
            a: klaviyoApiKey,
            platform: 'shopify',
            variant: variantId,
            email: email
        };

        const headers = {
            accept: 'application/json, text/plain, */*',
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
        };

        const body = new URLSearchParams(klaviyo_data);

        fetch(KLAVIYO_URL, {
            headers,
            body,
            method: 'POST'
        })
        .then(response => {
            this.alertFormBtn.classList.add('button--checked');
            this.alertFormBtn.querySelector('.js-form-alert-send').classList.add('hidden');
            this.alertFormBtn.querySelector('.js-form-alert-sent').classList.remove('hidden');
            this.alertFormBtn.removeEventListener('click', this.sendKlaviyoForm);
        })
        .catch(error => {
            this.alertFormBtn.classList.add('button--checked');
            this.alertFormBtn.querySelector('.js-form-alert-send').classList.add('hidden');
            this.alertFormBtn.querySelector('.js-form-alert-sent').classList.remove('hidden');
            this.alertFormBtn.removeEventListener('click', this.sendKlaviyoForm);
        });
    }

   isValidEmail = (value) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(value).toLowerCase());
    };
}

if (customElements.get('w3-stock-alert') === undefined) {
    customElements.define('w3-stock-alert', StockAlert);
}
